import { FC } from 'react';
import cn from 'classnames';

import { CategoryLabelProps } from './CategoryLabel.props';

export const CategoryLabel: FC<CategoryLabelProps> = ({
  categoryName,
  color = 'black',
  className,
}) => {
  return (
    <div
      className={cn(
        'bg-${color} inline-block cursor-default rounded-base px-2 py-[3px] text-sm text-white',
        className,
      )}
      style={{ backgroundColor: color }}
    >
      {categoryName}
    </div>
  );
};
